import type { CSSProperties } from "react";
import { Platform } from "react-native";

import type { IconProps } from "../types";

export type FontAwesomeKitIconProps = IconProps & {
  style?: "solid" | "regular" | "light" | "thin" | "semibold";
  cssStyle?: CSSProperties;
  name:
    | "cupcake"
    | "fish"
    | "leaf-heart"
    | "steak"
    | "crate-apple"
    | "dice"
    | "bell-exclamation"
    | "spoon"; // extend as needed
};

export const FontAwesomeKitIcon = ({
  size = 14,
  color = "#fff",
  style = "solid",
  name,
  cssStyle,
}: FontAwesomeKitIconProps) => {
  if (Platform.OS === "web") {
    return (
      <i
        style={{ fontSize: size, color: color as string, ...(cssStyle ?? {}) }}
        className={`fa-${style} fa-${name}`}
      />
    );
  }

  return null;
};
